import { Header } from "semantic-ui-react";

export const CustomHeader = (props: any) => (
  <Header as="h3" dividing color="red">
    {props.children}
  </Header>
);
